(function IIFE() {
    'use strict';

    /////////////////////////////

    function CustomContentTypeTagFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/customcontenttype/tag/:methodKey', {}, {
            get: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'get',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('CustomContentTypeTagFactory', CustomContentTypeTagFactory);
})();
